import React, {ReactElement} from 'react';
// TODO: INSTEAD OF USING MATERIAL UI COMPONENTS DIRECTLY, CREATE GENERIC COMPONENTS IN SYSTEM AND IMPORT IT
import {
  Button,
  // createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  makeStyles,
  DialogTitle,
  Divider,
  MenuItem,
  ListItemText
  // Radio
} from '@material-ui/core';

import {useTranslation} from 'react-i18next';
import './CopayCancelAlert.scss';
import HelperUtils from '@shared/utils/HelperUtils';
// import {copayDateTimeFormat} from '@shared/utils/DateTimeUtils';
import CheckBoxField from '@components/system/CheckBox/CheckBoxField';
import {
  APP_PRIMARY_COLOR,
  BUTTON_DISABLE_COLOR,
  DEFAULT_BLACK_COLOR,
  DEFAULT_GREY_COLOR,
  DEFAULT_WHITE_COLOR
} from 'src/style/variable';
import {getChargeTypeLabel} from '@shared/constants/Mapping';

const AlertStyles = makeStyles(() => ({
  root: {},
  filterHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1rem 16px'
  },
  menu: {
    '& li': {
      borderBottom: '1px solid #eeeeee'
    },
    '& li:last-child': {
      borderBottom: 'none'
    }
  },
  secondary: {
    '& .MuiListItemText-secondary': {
      fontSize: '0.9rem',
      overflow: 'hidden',
      width: '100%'
    }
  },

  primary: {
    '& .MuiListItemText-primary': {
      fontSize: '1.2rem',
      overflow: 'hidden',
      width: '100%'
    },
    padding: '0.5rem'
  },
  flex: {
    flex: 1
  },

  dropDownWidth: {
    minWidth: '15rem'
  },
  text: {
    fontSize: '1.3rem'
  },
  deleteClinicButton: {
    height: '3rem',
    width: '5rem',
    color: DEFAULT_WHITE_COLOR,
    borderRadius: '4pt',
    fontSize: '1.2rem',
    textTransform: 'capitalize',
    backgroundColor: APP_PRIMARY_COLOR,
    '&:hover': {
      backgroundColor: APP_PRIMARY_COLOR
    }
  },
  cancelButton: {
    height: '3rem',
    width: '5rem',
    color: DEFAULT_BLACK_COLOR,
    borderRadius: '4pt',
    fontSize: '1.2rem',
    textTransform: 'capitalize'
  },
  disableButton: {
    height: '3rem',
    width: '5rem',
    color: DEFAULT_GREY_COLOR,
    borderRadius: '4pt',
    fontSize: '1.2rem',
    textTransform: 'capitalize',
    backgroundColor: BUTTON_DISABLE_COLOR,
    '&:hover': {
      backgroundColor: BUTTON_DISABLE_COLOR
    }
  },
  chargeSection: {
    width: '25%'
  },
  breakLine: {
    whiteSpace: 'pre-line'
  },
  copaySection: {
    flexDirection: 'column',
    display: 'flex'
  },
  copayAuditInfo: {
    color: DEFAULT_GREY_COLOR,
    fontSize: '0.8rem'
  },
  locationColumn: {
    width: '15%',
    paddingRight: '0.5rem'
  },
  copaySecondaryTextWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.1rem',
    marginTop: '0.3rem'
  },
  copayColumn: {
    paddingRight: '0.5rem'
  },
  locationName: {
    marginTop: '0.3rem'
  }
}));
// FIXME: ADD INTERFACE FOR THE PROPS
const CopayCancelAlert = (props: any): ReactElement => {
  const {t} = useTranslation();
  const classes = AlertStyles();
  const {
    open,
    title,
    subtitle,
    list,
    close,
    copayCancelList,
    handleSelectCopay,
    cancelSelectedCopay
  } = props;

  const handleClose = () => {
    if (typeof close === 'function') {
      close();
    }
  };

  const handleOnClick = (item: any) => {
    if (typeof handleSelectCopay === 'function') {
      handleSelectCopay(item);
    }
  };

  const handleConfirm = () => {
    if (typeof cancelSelectedCopay === 'function') {
      cancelSelectedCopay();
    }
  };
  // FIXME: SHOW THE DATA IN A TABLE SO THAT COLUMN CAN HAVE WIDTH BASED ON CONTENT.
  const renderBody = () => {
    return (
      <div className={classes.menu}>
        {list.map((item: any, index: number) => (
          <MenuItem
            data-test-id={`pcl-copayChargesComponent-removeCopay${index}`}
            key={item.charge_amount}
            value={item.charge_amount}
            onClick={(): void => handleOnClick(item)}>
            <ListItemText
              className={[
                classes.secondary,
                classes.primary,
                classes.breakLine,
                classes.locationColumn
              ].join(' ')}
              primary={t(t('PATIENT_DETAILS_CARD.LOCATION'))}
              secondary={
                <p className={classes.locationName}>
                  {item?.['clinic_detail']?.name ?? ''}
                </p>
              }
            />
            <ListItemText
              className={[
                classes.secondary,
                classes.primary,
                classes.chargeSection,
                classes.breakLine,
                classes.copaySection
              ].join(' ')}
              primary={<span>{t(getChargeTypeLabel(item?.charge_type))}</span>}
              secondary={
                <p className={classes.copaySecondaryTextWrapper}>
                  <span className={classes.copayAuditInfo}>
                    {item?.description
                      ? item?.description
                      : t('PATIENTS.COPAY_NOTES')}
                  </span>
                  <span className={classes.copayAuditInfo}>
                    {t('COMMON.ADDED_BY', {
                      name: HelperUtils.commaSeparatedFullName(
                        item?.user?.first_name,
                        item?.user?.last_name
                      )
                    })}
                  </span>
                  <span className={classes.copayAuditInfo}>
                    {t('COMMON.AT', {
                      date: HelperUtils.formatDisplayDate(
                        item?.created_at,
                        'MM/DD/YYYY'
                      )
                    })}
                  </span>
                </p>
              }
            />
            <ListItemText
              className={[classes.secondary, classes.primary].join(' ')}
              primary={`$${HelperUtils.fixTo2Decimals(
                Number(item.charge_amount || 0) - Number(item.paid_amount || 0)
              )}`}
            />

            <CheckBoxField
              checked={HelperUtils.getCheck(copayCancelList, item?.id)}
            />
          </MenuItem>
        ))}
      </div>
    );
  };

  return (
    <div>
      <Dialog
        open={open}
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        fullWidth={true}
        maxWidth={'md'}
        className={classes.root}>
        <DialogTitle disableTypography>
          {title}
          <div className="sub">{subtitle}</div>
        </DialogTitle>
        <Divider />
        <DialogContent>{renderBody()}</DialogContent>
        <Divider />
        <DialogActions style={{display: 'flex'}}>
          <Button
            className={classes.cancelButton}
            onClick={() => handleClose()}>
            {t('DUE_INVOICES.NOTIFICATION_DIALOG.BUTTON_CANCEL')}
          </Button>
          <Button
            disabled={!copayCancelList?.length}
            className={
              !copayCancelList?.length
                ? classes.disableButton
                : classes.deleteClinicButton
            }
            onClick={() => handleConfirm()}>
            {t('COMMON.CONFIRM')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CopayCancelAlert;
